import '../../modal/components/modal/modal.component.scss';
import './membership-modal-extensions.scss';

import type { FunctionComponent } from 'preact';

import { useTranslation } from '../../i18n';

export interface MembershipConfirmCancelPendingActionModalProps {
  title: string;
  message: string;
  confirmText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const MembershipConfirmCancelPendingActionModal: FunctionComponent<
  MembershipConfirmCancelPendingActionModalProps
> = ({ title, message, confirmText, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div class="single-confirm-cancel-pending-action-modal">
      {title && (
        <div class="single-modal-header">
          <h3 class="single-modal-title">{title}</h3>
        </div>
      )}
      <div class="single-modal-body">
        <p class="message" dangerouslySetInnerHTML={{ __html: message }} />
      </div>
      <div class="single-modal-footer single-action-list inline--btns">
        <button className="btn button" onClick={onCancel} type="button">
          {t('membership.noGoBack')}
        </button>
        <button className="btn button btn-red" onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </div>
  );
};
